import { render, staticRenderFns } from "./HomeSupportAssistance.vue?vue&type=template&id=9bc3fb1c&scoped=true&"
import script from "./HomeSupportAssistance.vue?vue&type=script&lang=js&"
export * from "./HomeSupportAssistance.vue?vue&type=script&lang=js&"
import style0 from "./HomeSupportAssistance.vue?vue&type=style&index=0&id=9bc3fb1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc3fb1c",
  null
  
)

export default component.exports